module.exports = __webpack_public_path__ + "static/media/052.fe7f18a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/052.jpg
// module id = 397
// module chunks = 0